import styled from 'styled-components';

import { Div } from 'common/styles/oc-styled-components';

export const Text = styled(Div)`
  position: relative;
  height: ${(props) => (props.expanded ? 'auto' : '73px')};
  overflow: hidden;

  &:after {
    content: '';
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 70%;
    height: ${(props) => (props.expanded ? '0' : '20px')};
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1) 50%
    );
  }
`;
